import { isTerminalApiError } from '@omnea-app/packages/universal/error-handling/isApiErrorOfType'

export const resolvePollingInterval = (error: unknown, interval: number | undefined): number | false =>
  isTerminalApiError(error) ? false : (interval ?? false)
